export default __webpack_public_path__ + "static/media/paso2.31d8eadb.png";